// 056B — Adolescente Hombre (curvas de crecimiento y Tanner; páginas 200-201 del PDF). Ver `bloques056abDatos.ts`.
import { crearFormularioAdolescente } from './FormularioAdolescente';

export const Formulario056B = crearFormularioAdolescente('056B', 'male');
